module.exports = __webpack_public_path__ + "img/textimage.c4a178ea.svg";